import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListCause } from "../../../components/Admin/Cause";
import { useLanguage } from "../../../contexts";
import "./Cause.scss";

export function Causes() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: "Causas activas",
      render: () => (
        <Tab.Pane attached={false}>
          <ListCause active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Causas inactivas",
      render: () => (
        <Tab.Pane attached={false}>
          <ListCause active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="cause-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="cause-page-header-wrapper">
        <div className="cause-page-header">
          <span className="cause-page-title">{t("causes")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
